import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { createListing, uploadImage } from '../lib/supabase';

const CATEGORIES = [
  'Clothing & Accessories',
  'Household',
  'Furniture',
  'Toys & Games',
  'Tools & Garden',
  'Electronics & Media',
  'Kitchenware',
  'Sports Equipment',
  'Miscellaneous',
];

export default function CreateListing() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: '', price: '', available_date: '', category: '' });
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { setError('Image must be under 5 MB.'); return; }
    setError('');
    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!user) return navigate('/login');
    setError('');
    setLoading(true);
    try {
      let image_url = null;
      if (imageFile) image_url = await uploadImage(imageFile, user.id);

      await createListing({
        user_id: user.id,
        title: form.title.trim(),
        price: form.price === `` ? 0 : parseFloat(form.price),
        available_date: form.available_date || null,
        category: form.category || null,
        image_url,
        status: 'available',
      });
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="form-wrap">
        <div className="form-card">
          <div className="form-head">
            <h2>List an Item</h2>
            <p>Fill in the details to post your item for sale.</p>
          </div>

          {error && <div className="alert alert-e">{error}</div>}

          <form onSubmit={submit}>
            <div className="fg">
              <label>Title and Description *</label>
              <input value={form.title} onChange={set('title')} placeholder="What are you selling?" required />
            </div>

            <div className="fg">
              <label>Price (USD) *</label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={form.price}
                onChange={set('price')}
                placeholder="0.00"
                required
              />
            </div>

            <div className="fg">
              <label>Photo</label>
              <div
                className={`upload-area ${preview ? 'has' : ''}`}
                onClick={() => document.getElementById('img-input').click()}
              >
                {preview
                  ? <img className="upload-preview" src={preview} alt="Preview" />
                  : <div>
                      <div style={{ fontSize: '2rem', marginBottom: '.5rem' }}>📷</div>
                      <div style={{ fontSize: '.875rem', color: 'var(--brown)' }}>Click to upload a photo</div>
                    </div>
                }
              </div>
              <input id="img-input" type="file" accept="image/*" style={{ display: 'none' }} onChange={handleImage} />
              {preview && (
                <button type="button" className="btn btn-g btn-sm" style={{ marginTop: '.5rem' }}
                  onClick={() => { setPreview(null); setImageFile(null); }}>
                  Remove photo
                </button>
              )}
            </div>

            <div className="fg">
              <label>Category <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
              <select value={form.category} onChange={set('category')} style={{ width: '100%' }}>
                <option value="">— Select a category —</option>
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div className="fg">
              <label>Available Date <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
              <input type="date" value={form.available_date} onChange={set('available_date')} />
              <div className="hint">Leave blank if available immediately.</div>
            </div>

            <div style={{ display: 'flex', gap: '.75rem', marginTop: '.5rem' }}>
              <button className="btn btn-g" type="button" onClick={() => navigate(-1)}>Cancel</button>
              <button className="btn btn-p" type="submit" disabled={loading} style={{ flex: 1 }}>
                {loading ? 'Posting…' : 'Post Listing'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
